import styled from 'styled-components'

export const StSignableDocumentWrapper = styled.div<{ hidden?: boolean }>`
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`
